import { TraductionPdp } from "./traduction-pdp.entity";

export class TraductionDto {
	
	traduction: TraductionPdp;
	responsibility: undefined | string;
	autre: undefined | string;
	poidsFemme: undefined | number;
	poidsHomme: undefined | number;

	constructor(traductionId: number, responsibility: string, autre: string, poidsFemme: number, poidsHomme: number, traductionKey: string, fr: string, type: string, parent: TraductionPdp) {
		this.traduction = new TraductionPdp();
		this.traduction.id = traductionId;
		this.responsibility = responsibility === "" ? undefined : responsibility;
		this.autre = autre === ""  ? undefined : autre;
		this.poidsFemme = !poidsFemme && traductionKey === 'MANU_MAN_MP4' ? 15 : poidsFemme;
		this.poidsHomme = !poidsHomme && traductionKey === 'MANU_MAN_MP4' ? 25 : poidsHomme;
		if ((traductionKey.trim().startsWith('AUTR') || traductionKey.trim().startsWith('EXTENDED_AUTR')) && fr.length > 0) {
			this.traduction.traductionKey = traductionKey;
			this.traduction.fr = fr;
			this.traduction.en = fr;
			this.traduction.es = fr;
			this.traduction.type = type;
			this.traduction.parent = parent;
			this.traduction.id = -1;
		}
	}
}